import React from 'react';
import PropTypes from 'prop-types';
import {CheckboxRadioGroup, CheckboxRadio} from '@ignitesales/react-checkbox-radio';
import classNames from 'classnames';

const CheckboxRadioButtons = props => {
  const {
    name,
    checkedValues,
    answerOptions,
    onChange,
    type,
    className,
    renderLabel
  } = props;

  const classes = classNames(
    'checkboxRadioButton',
    className
  );

  const renderAnswerOptions = () => {
    return answerOptions.map( (option, index) => {
      const inputClasses = classNames({
        'checkboxRadioButton__option': true,
        'btn' : true,
        'checkboxRadioButton__option--checked' : Array.isArray(checkedValues) ? (checkedValues.indexOf(option.value) >= 0) : checkedValues === option.value
      });

      const label = renderLabel ? renderLabel(option) : <span className="checkboxRadioButton__option__label">{option.label}</span>;

      return <label className={inputClasses} key={`${name}-${index}`}>
        <CheckboxRadio value={option.value} />
        {label}
        <span className="checkboxRadioButton__option__tooltip">&nbsp;{option.tooltip}</span>
      </label>;
    });
  };

  return <CheckboxRadioGroup
    name={name}
    className={classes}
    checkboxDepth={2}
    onChange={onChange}
    type={type}
    value={checkedValues}
  >
    { renderAnswerOptions() }
  </CheckboxRadioGroup>;
};

const AnswerOptionShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.any,
  tooltip: PropTypes.any
});
CheckboxRadioButtons.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  checkedValues: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.any)
  ]),
  answerOptions: PropTypes.oneOfType([
    AnswerOptionShape,
    PropTypes.arrayOf(AnswerOptionShape)
  ]).isRequired
};




export default CheckboxRadioButtons;
